import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import './DailyResetTimer.scss';

const DailyResetTimerSkeleton = () => {
  return (
    <div className="daily-reset-timer">
      <Skeleton 
        width="180px" 
        height="16px" 
        variant="text"
        className="daily-reset-timer-skeleton__label"
      />
      <Skeleton 
        width="120px" 
        height="24px" 
        variant="text"
        className="daily-reset-timer-skeleton__countdown"
      />
    </div>
  );
};

export default DailyResetTimerSkeleton;